import { Fragment } from "react";

import useAccountCreationParentPhoneNumber from "./UseAccountCreationParentPhoneNumber";

import ParentPhoneForm from "../../components/forms/ParentPhoneNumberForm";

import Headings from "@usas/ui-web/components/headings/Headings";
import PopUpModal from "@usas/ui-web/components/dialogs/PopUpModal";
import SecondaryButton from "@usas/ui-web/components/buttons/SecondaryButton";

import Constants from "@usas/ui-web/utils/Constants";
import style from '../../../../LandingPages.module.css';

const AccountCreationParentPhoneNumber = () => {
  const {
    parentPhoneData,
    isLoading,
    verificationErrorPopupState,
    onBackClicked,
    onCloseVerificationErrorPopupClicked,
    onSubmitFormCallback
  } = useAccountCreationParentPhoneNumber();

  return (
    <Fragment>
      <div className="row usas-extra-bottom-margin">
        <div className="col-xs-12 col-md-4" />
        <div className={['col-xs-12', 'col-md-4', style.CenterPageContent].join(' ')}>
          <Headings.H3>Parent/Guardian Phone Number</Headings.H3>
          <p>
            We may text your parent to obtain your consent to creation of your Login account. 
            For more information, see our <a href="https://www.usaswimming.org/landing-pages/privacy-policy" target="_blank" rel="noreferrer">Privacy Policy. </a>
            
          </p>
          <ParentPhoneForm
            parentPhoneData={parentPhoneData}
            onSubmitFormCallback={onSubmitFormCallback}
            onSecondaryButtonClicked={onBackClicked} />
        </div>
        <div className="col-xs-12 col-md-4" />
      </div>
      <PopUpModal
        widthPct={60}
        maxWidth={720}
        title={'Parent Verification Error'}
        displayPopUp={verificationErrorPopupState.displayPopup === true}>
        <div className="row">
          <div className="col-xs-12">
            <p>{verificationErrorPopupState.errorMessage || 'An error occurred during parent verification.'}</p>
          </div>
        </div>
        <div className="row">
          <div className="col-xs-12">
            <SecondaryButton type={'button'} onClick={onCloseVerificationErrorPopupClicked}>Close</SecondaryButton>
          </div>
        </div>
      </PopUpModal>
      <PopUpModal
        widthPct={50}
        maxWidth={250}
        title={Constants.LOADING_MSG}
        displayPopUp={isLoading} />
    </Fragment>
  );
};

export default AccountCreationParentPhoneNumber;